import React from 'react';
import { Card, CardContent, Stack } from '@mui/material';
import {
  Hub,
  Security,
  Storage as StorageIcon,
  Assessment,
} from '@mui/icons-material';
import CompactInfrastructureCard from '../common/CompactInfrastructureCard';

export default function InfrastructurePanel({
  rabbitmqStatus,
  tarantoolStatus,
  mongodbStatus,
  clickhouseStatus,
  kratosStatus,
  infrastructureLoading,

  // RabbitMQ
  handleRabbitMQHealth,
  handleRabbitMQDetails,
  handleRabbitMQTest,

  // Kratos
  handleKratosHealth,
  handleKratosAdminHealth,
  handleKratosUsers,
  handleKratosDetails,
  handleKratosDetailed,

  // Tarantool
  handleTarantoolHealth,
  handleTarantoolDetailed,

  // MongoDB
  handleMongoDBHealth,
  handleMongoDBDetailed,

  // ClickHouse
  handleClickHouseHealth,
  handleClickHouseDetailed,
}) {
  const loading = infrastructureLoading || {};

  return (
    <Card sx={{ flexShrink: 0 }}>
      <CardContent sx={{ p: 0.75, '&:last-child': { pb: 0.75 } }}>
        <Stack spacing={0.75}>
          <CompactInfrastructureCard
            title="RabbitMQ"
            icon={<Hub />}
            status={rabbitmqStatus}
            onCheck={handleRabbitMQHealth}
            onDetailed={handleRabbitMQDetails}
            loading={loading.rabbitmq}
            testLabel="Тест публикации"
            onTest={handleRabbitMQTest}
          />

          <CompactInfrastructureCard
            title="Kratos Auth"
            icon={<Security />}
            status={kratosStatus?.public}
            onCheck={handleKratosHealth}
            onDetailed={handleKratosDetails}
            loading={loading.kratos}
            testLabel="Статистика"
            onTest={handleKratosUsers}
            adminTestLabel="Admin API"
            onAdminTest={handleKratosAdminHealth}
            adminLoading={loading.kratos_admin}
            detailedTestLabel="Детальная диагностика"
            onDetailedTest={handleKratosDetailed}
          />

          <CompactInfrastructureCard
            title="Tarantool"
            icon={<StorageIcon />}
            status={tarantoolStatus}
            onCheck={handleTarantoolHealth}
            onDetailed={handleTarantoolDetailed}
            loading={loading.tarantool}
          />

          <CompactInfrastructureCard
            title="MongoDB"
            icon={<StorageIcon />}
            status={mongodbStatus}
            onCheck={handleMongoDBHealth}
            onDetailed={handleMongoDBDetailed}
            loading={loading.mongodb}
          />

          <CompactInfrastructureCard
            title="ClickHouse"
            icon={<Assessment />}
            status={clickhouseStatus}
            onCheck={handleClickHouseHealth}
            onDetailed={handleClickHouseDetailed}
            loading={loading.clickhouse}
          />
        </Stack>
      </CardContent>
    </Card>
  );
}
